//import { renderTittel } from './tittel.html'
import styles from './tittel.module.css'
import './avslortlogo.svg'
import lottie from 'lottie-web'
import avslortlogoLottie from './avslortlogo.json'

const titleAnimationNames = [styles.titleOut, styles.ingressIn]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function hydrate(el, props) {
  const lottieContainer = el.querySelector('#logo-container')
  const avslortLogoAnimation = lottie.loadAnimation({
    container: lottieContainer,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: avslortlogoLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
    },
  })

  avslortLogoAnimation.play()

  const handleInteraction = () => {
    if ('getAnimations' in document) {
      const titleAnimations = document
        .getAnimations()
        .filter(({ animationName }) => titleAnimationNames.includes(animationName))

      for (const titleAnimation of titleAnimations) {
        if (
          titleAnimation.animationName.includes('title-out') &&
          titleAnimation.playState === 'running'
        ) {
          el.dispatchEvent(new CustomEvent('title.skip', {}))
        }
        titleAnimation.playbackRate = 7
      }
    }
    document.removeEventListener('scroll', handleInteraction)
    document.querySelector('h1')?.removeEventListener('focus', handleInteraction)
  }

  //el.innerHTML = render(props)
  document.addEventListener('scroll', handleInteraction)
  document.querySelector('h1')?.addEventListener('focus', handleInteraction)
}
